var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookerSwitch01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.cls-1 {\n\t\t\tfill: none;\n\t\t\t}\n\n\t\t\t.cls-1, .cls-2 {\n\t\t\tstroke: #FFFFFF;\n\t\t\tstroke-miterlimit: 10;\n\t\t\tstroke-width: 0.25px;\n\t\t\t}\n\n\t\t\t.cls-2 {\n\t\t\tfill: #FFFFFF;\n\t\t\t}\n\t\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cooker Switch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.69,
    y: 4.33,
    width: 10.63,
    height: 7.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.23,
    cy: 8,
    r: 3.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.69,
    y1: 11.67,
    x2: 5.19,
    y2: 10.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.31,
    y1: 11.67,
    x2: 11.17,
    y2: 10.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.69,
    y1: 4.33,
    x2: 5.19,
    y2: 5.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.17,
    y1: 5.82,
    x2: 13.31,
    y2: 4.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.24,5.67A3.84,3.84,0,0,0,8.36,4.34,3.62,3.62,0,0,0,5.19,5.86L8.16,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.19,10.09a3.44,3.44,0,0,0,2.73,1.57,3.63,3.63,0,0,0,3.17-1.5L8.13,8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookerSwitch01);
export default __webpack_public_path__ + "static/media/CookerSwitch-01.4be6465267b8218df17c42a42caf0e2b.svg";
export { ForwardRef as ReactComponent };